<template>
    <el-table
            :data="propsTableData"
            style="width: 100%"
            class="table-wrap">
        <el-table-column
                prop="hasAtta"
                width="30"
                align="center">
            <template slot-scope="scope">
                <span v-show="scope.row.hasAtta==true" >
                            <svg class="icon" aria-hidden="true" style="font-size:24px;color:#888888;">
                                <use xlink:href="#icon-biaoqianshuqianhuixingzhen"></use>
                            </svg>
                </span>
                <span v-show="scope.row.hasAtta==false"></span>
            </template>
        </el-table-column>
        <el-table-column
                prop=""
                label="状态"
                align="center"
                width="100"
                class="table-column">
            <template slot-scope="scope">
                <span v-if="!scope.row.medicalScore&&!scope.row.systemScore">待评价</span>
                <span v-else="scope.row.medicalScore||scope.row.systemScore">已评价</span>
            </template>
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consultGroupNo"-->
                <!--label="编号"-->
                <!--align="center"-->
                <!--class="table-column"-->
                <!--show-overflow-tooltip>-->
        <!--</el-table-column>-->
        <el-table-column
                prop="consulterName"
                label="患者"
                class="table-column"
                align="center">
        </el-table-column>
        <!--<el-table-column-->
                <!--prop="consulterGender"-->
                <!--label="性别"-->
                <!--:formatter="sexSelect"-->
                <!--class="table-column"-->
                <!--align="center">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
                <!--prop="consulterAge"-->
                <!--label="年龄"-->
                <!--class="table-column"-->
                <!--align="center">-->
        <!--</el-table-column>-->
        <el-table-column
                prop="initHosName"
                label="申请机构"
                show-overflow-tooltip
                align="center"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="initDeptName"
                label="申请科室"
                show-overflow-tooltip
                align="center"
                class="table-column"
                show-overflow-tooltip>
        </el-table-column>
        <el-table-column
                prop="initDocName"
                label="申请医生"
                align="center"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="createTime"
                label="申请时间"
                :formatter="formatUnix"
                align="center"
                width="60"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="acceptHosName"
                label="会诊机构"
                show-overflow-tooltip
                align="center"
                class="table-column"
                width="75">
        </el-table-column>
        <el-table-column
                prop="acceptDeptName"
                label="会诊科室"
                show-overflow-tooltip
                align="center"
                class="table-column"
                width="80">
        </el-table-column>
        <el-table-column
                prop="acceptDocName"
                label="会诊专家"
                show-overflow-tooltip
                align="center"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="consultTime"
                label="安排会诊"
                :formatter="formatUnixConsultTime"
                width="60"
                align="center">
        </el-table-column>
        <el-table-column
                prop="modifierName"
                label="最后处理人"
                align="center"
                class="table-column">
        </el-table-column>
        <el-table-column
                prop="modifyTime"
                label="最后处理"
                :formatter="formatModifyUnix"
                align="center"
                width="60"
                class="table-column">
        </el-table-column>

        <el-table-column
                prop="operation"
                label=" 操作"
                align="center"
                inline-template
                class="table-column"
                width="180">
            <div class="table-btn-wrap">
                <el-button
                        size="small"
                        @click="linkToView($index, row)"
                        class="table-btn ghost-btn">
                    会诊单
                </el-button>
                <el-button
                        size="small"
                        @click="linkToDeal($index, row)"
                        class="table-btn ghost-btn">
                    详情
                </el-button>
            </div>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
    import { Table,Button,TableColumn, Tooltip } from "element-ui";
    import { formatUnixTime } from "../../utils/DateFormat.js";
    import Vue from "vue";
    Vue.use(Table);
    Vue.use(Button);
    Vue.use(TableColumn);
    Vue.use(Tooltip);
    export default{
        props: ["propsTableData", "tableType"],
        components:{

        },
        methods: {
            formatUnix: function(row, column){//格式化时间格式
                return formatUnixTime(row.createTime, "MM-dd HH:mm");
            },
            formatUnixConsultTime: function (row, column) {//格式化会诊时间
                if(row.consultTime){
                    return formatUnixTime(row.consultTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            sexSelect: function(row, column){//根据服务器获取到的M或者其他显示男或女
                return (row.consulterGender =="M"?"男":"女");
            },
            formatModifyUnix: function(row, column){//格式化最后处理时间格式
                if(row.modifyTime){
                    return formatUnixTime(row.modifyTime, "MM-dd HH:mm");
                }else {
                    return "";
                }
            },
            linkToView: function($index, row){
                this.$router.push({ name: "printRemoteSheet", params: { consultId: row.id ,printDetail:row}} );
            },
            linkToDeal: function($index, row){
                this.$store.dispatch("getCurrentPosition", this.tableType);// 更改侧边栏列表获取数据
                this.$router.push({ name: "remoteEvaluate", params: { consultId: row.id }} );
                localStorage.setItem("consultId",row.id);
            },
        }
    }
</script>
